import Quill from "quill";
import { MentionDeletedEvent } from "@webapp/shared/rich-text-editor/events/mention-deleted.event";

const Embed = Quill.import("blots/embed");

export class MentionBlot extends Embed {
  private hoverHandler;
  private container;

  constructor(scroll, node) {
    super(scroll, node);

    this.clickHandler = null;
    this.hoverHandler = null;
    this.mounted = false;
  }

  public static create(data): unknown {
    const node = super.create();
    const denotationChar = document.createElement("span");
    denotationChar.className = "ql-mention-denotation-char";
    denotationChar.innerHTML = data.denotationChar;
    node.appendChild(denotationChar);
    node.innerHTML += data.value;
    return MentionBlot.setDataValues(node, data);
  }

  public static setDataValues(element, data): unknown {
    const domNode = element;
    Object.keys(data).forEach((key) => {
      domNode.dataset[key] = data[key];
    });
    return domNode;
  }

  public static value(domNode): unknown {
    return domNode.dataset;
  }

  public attach(): void {
    super.attach();

    if (!this.mounted) {
      this.mounted = true;
      this.clickHandler = this.getClickHandler();
      this.hoverHandler = this.getHoverHandler();

      this.domNode.addEventListener("click", this.clickHandler, false);
      this.domNode.addEventListener("mouseenter", this.hoverHandler, false);
      this.container = this.domNode.closest(".rich-text-editor-container");
    }
  }

  public detach(): void {
    super.detach();
    this.mounted = false;

    if (this.clickHandler) {
      this.domNode.removeEventListener("click", this.clickHandler);
      this.clickHandler = null;
    }

    if (this.hoverHandler) {
      this.domNode.removeEventListener("mouseenter", this.hoverHandler);
      this.hoverHandler = null;
    }

    const event = new MentionDeletedEvent("mention-deleted", {
      bubbles: true,
      cancelable: true,
    });
    event.userId = this.domNode?.dataset?.id;

    this.container?.dispatchEvent(event);
  }

  public getClickHandler() {
    return (e): void => {
      const event = this.buildEvent("mention-clicked", e);
      this.container?.dispatchEvent(event);

      e.preventDefault();
    };
  }

  public getHoverHandler() {
    return (e): void => {
      const event = this.buildEvent("mention-hovered", e);
      this.container?.dispatchEvent(event);

      e.preventDefault();
    };
  }

  /**
   * Send event will data attributes from the mention field
   * Attach the source dom element to the event
   */
  public buildEvent(name: string, e: Event): CustomEvent {
    return new CustomEvent(name, {
      detail: {
        value: Object.assign({}, this.domNode.dataset),
        event: e,
        domNode: this.domNode,
      },
    });
  }
}

MentionBlot.blotName = "ghMention";
MentionBlot.tagName = "span";
MentionBlot.className = "mention";
